import { render } from "./EditEmployee.vue?vue&type=template&id=04b81171"
import script from "./EditEmployee.vue?vue&type=script&lang=js"
export * from "./EditEmployee.vue?vue&type=script&lang=js"

import "./EditEmployee.vue?vue&type=style&index=0&id=04b81171&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__